<template>
    <div class="classify-page">
        <div class="container">
            <div class="handle-box">
                <div style="width: 50%;">
                    <span class="title">分类管理</span>
                </div>
                <div>
                    <el-button type="primary" @click="tianC = true" icon="el-icon-plus">添加分类</el-button>
                </div>
            </div>
            <el-table :data="classifyList" border class="table table-then-card" ref="filterTable" v-loading="loadingC">
                <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
                <el-table-column prop="sort" label="排序" align="center"></el-table-column>
                <el-table-column label="操作模式" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type === 1" type="success">二级分类</el-tag>
                        <el-tag v-else-if="scope.row.type === 2" type="warning">自定义跳转</el-tag>
                        <el-tag v-else type="info">未设置</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center" width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column label="操作" width="300" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-s-grid" style="color:#409EFF"
                            @click="handleSubManage(scope.row)">
                            管理子分类
                        </el-button>
                        <el-button type="text" icon="el-icon-edit-outline" style="color:green"
                            @click="handleClassifyUp(scope.$index, scope.row)">
                            修改
                        </el-button>
                        <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                            @click="handleClassifyDe(scope.$index, scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 手机端卡片列表 -->
            <div class="mobile-card-list" v-loading="loadingC">
                <div v-for="(row, idx) in classifyList" :key="row.cid" class="mc-card">
                    <div class="mc-header">
                        <div class="mc-header-left">
                            <span class="mc-title">{{ row.name }}</span>
                            <el-tag v-if="row.type === 1" type="success" size="small">二级分类</el-tag>
                            <el-tag v-else-if="row.type === 2" type="warning" size="small">自定义跳转</el-tag>
                            <el-tag v-else type="info" size="small">未设置</el-tag>
                        </div>
                        <span class="mc-subtitle">排序: {{ row.sort }}</span>
                    </div>
                    <div class="mc-actions">
                        <el-button size="small" type="primary" icon="el-icon-s-grid" @click="handleSubManage(row)">管理子分类</el-button>
                        <el-button size="small" icon="el-icon-edit-outline" style="color:green" @click="handleClassifyUp(idx, row)">修改</el-button>
                        <el-button size="small" type="danger" icon="el-icon-delete" @click="handleClassifyDe(idx, row)">删除</el-button>
                    </div>
                </div>
                <div v-if="!loadingC && classifyList.length === 0" style="text-align:center;color:#909399;padding:30px 0;">暂无数据</div>
            </div>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentClassifyChange" :current-page.sync="pageC"
                    :page-size="sizeC" layout="total, prev, pager, next" :total="classifyTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="添加分类" :visible.sync="tianC" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rulesA" ref="cyObj" label-width="150px" :model="cyObj" status-icon>
                <el-form-item label="分类名称" prop="name">
                    <el-input placeholder="请输入分类名称" prefix-icon="el-icon-edit" v-model="cyObj.name"></el-input>
                </el-form-item>
                <el-form-item label="排 序" prop="sort">
                    <el-input-number v-model="cyObj.sort"></el-input-number>
                </el-form-item>
                <el-form-item label="操作模式" prop="type">
                    <el-radio-group v-model="cyObj.type">
                        <el-radio :label="1">二级分类展示模式</el-radio>
                        <el-radio :label="2">自定义图文页面</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="封面图" v-if="cyObj.type === 1">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="uploadClassifyCover" :auto-upload="true" :on-success="handleClassifyCoverSuccess"
                        :on-remove="handleClassifyCoverRemove" :file-list="fileListCover" :limit="1">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="页面内容" v-if="cyObj.type === 2">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="cyObj.details" class="editor" />
                </el-form-item>
                <el-form-item label="跳转链接" v-if="cyObj.type === 1">
                    <el-input placeholder="请输入跳转链接" prefix-icon="el-icon-link" v-model="cyObj.link"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subCAdd('cyObj')">确 定</el-button>
                <el-button @click="tianC = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改分类" :visible.sync="upgC" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rulesU" ref="cyUObj" label-width="150px" :model="cyUObj" status-icon>
                <el-form-item label="分类名称" prop="name">
                    <el-input placeholder="请输入分类名称" prefix-icon="el-icon-edit" v-model="cyUObj.name"></el-input>
                </el-form-item>
                <el-form-item label="排 序" prop="sort">
                    <el-input-number v-model="cyUObj.sort"></el-input-number>
                </el-form-item>
                <el-form-item label="操作模式" prop="type">
                    <el-radio-group v-model="cyUObj.type">
                        <el-radio :label="1">二级分类展示模式</el-radio>
                        <el-radio :label="2">自定义图文页面</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="封面图" v-if="cyUObj.type === 1">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="uploadClassifyCover" :auto-upload="true" :on-success="handleClassifyCoverSuccess"
                        :on-remove="handleClassifyCoverRemove" :file-list="fileListUCover" :limit="1">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="页面内容" v-if="cyUObj.type === 2">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="cyUObj.details" class="editor" />
                </el-form-item>
                <el-form-item label="跳转链接" v-if="cyUObj.type === 1">
                    <el-input placeholder="请输入跳转链接" prefix-icon="el-icon-link" v-model="cyUObj.link"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subCUp('cyUObj')">确 定</el-button>
                <el-button @click="upgC = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 子分类管理 -->
        <el-dialog title="子分类管理" :visible.sync="subShow" :width="dialogWidth">
            <div class="handle-box">
                <el-button type="primary" @click="subTian = true" icon="el-icon-plus">添加子分类</el-button>
            </div>
            <el-table :data="subList" border class="table table-then-card" v-loading="loadingC">
                <el-table-column label="分类图片" align="center" width="120">
                    <template slot-scope="scope">
                        <el-image class="table-td-thumb" :src="scope.row.imageUrl" v-if="scope.row.imageUrl"></el-image>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="分类名称" align="center"></el-table-column>
                <el-table-column label="操作模式" align="center" width="130">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.type === 2" type="warning" size="small">跳转链接</el-tag>
                        <el-tag v-else type="success" size="small">商品展示</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center" width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit-outline" style="color:green"
                            @click="handleSubUp(scope.$index, scope.row)">
                            修改
                        </el-button>
                        <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                            @click="handleSubDe(scope.$index, scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 手机端卡片列表 - 子分类 -->
            <div class="mobile-card-list" v-loading="loadingC">
                <div v-for="(row, idx) in subList" :key="idx" class="mc-card">
                    <div class="mc-thumb-area" v-if="row.imageUrl && row.type !== 2">
                        <el-image class="mc-img" :src="row.imageUrl" fit="cover"></el-image>
                        <div class="mc-thumb-info">
                            <div class="mc-title">{{ row.name }}</div>
                        </div>
                    </div>
                    <div class="mc-header">
                        <div class="mc-header-left">
                            <span class="mc-title">{{ row.name }}</span>
                            <el-tag v-if="row.type === 2" type="warning" size="small">跳转链接</el-tag>
                            <el-tag v-else type="success" size="small">商品展示</el-tag>
                        </div>
                    </div>
                    <div class="mc-grid-2">
                        <div class="mc-row">
                            <span class="mc-label">排序</span>
                            <span class="mc-value">{{ row.sort }}</span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">创建时间</span>
                            <span class="mc-value">{{ row.createTime }}</span>
                        </div>
                    </div>
                    <div class="mc-actions">
                        <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="handleSubUp(idx, row)">修改</el-button>
                        <el-button size="small" type="danger" icon="el-icon-delete" @click="handleSubDe(idx, row)">删除</el-button>
                    </div>
                </div>
                <div v-if="!loadingC && subList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无子分类</div>
            </div>
        </el-dialog>

        <!-- 添加子分类 -->
        <el-dialog title="添加子分类" :visible.sync="subTian" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rulesSub" ref="subObj" label-width="150px" :model="subObj" status-icon>
                <el-form-item label="子分类名称" prop="name">
                    <el-input placeholder="请输入子分类名称" prefix-icon="el-icon-edit" v-model="subObj.name"></el-input>
                </el-form-item>
                <el-form-item label="排 序" prop="sort">
                    <el-input-number v-model="subObj.sort"></el-input-number>
                </el-form-item>
                <el-form-item label="操作模式" prop="type">
                    <el-radio-group v-model="subObj.type">
                        <el-radio :label="1">分类商品展示</el-radio>
                        <el-radio :label="2">自定义跳转链接</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分类图片" v-if="subObj.type === 1">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="uploadSubImage" :auto-upload="true" :on-success="handleSubImageSuccess"
                        :on-remove="handleSubImageRemove" :file-list="fileListSub" :limit="1">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="跳转链接" v-if="subObj.type === 2">
                    <el-input placeholder="请输入跳转链接" prefix-icon="el-icon-link" v-model="subObj.link"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subSubAdd('subObj')">确 定</el-button>
                <el-button @click="subTian = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 修改子分类 -->
        <el-dialog title="修改子分类" :visible.sync="subUpg" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rulesSubU" ref="subUObj" label-width="150px" :model="subUObj" status-icon>
                <el-form-item label="子分类名称" prop="name">
                    <el-input placeholder="请输入子分类名称" prefix-icon="el-icon-edit" v-model="subUObj.name"></el-input>
                </el-form-item>
                <el-form-item label="排 序" prop="sort">
                    <el-input-number v-model="subUObj.sort"></el-input-number>
                </el-form-item>
                <el-form-item label="操作模式" prop="type">
                    <el-radio-group v-model="subUObj.type">
                        <el-radio :label="1">分类商品展示</el-radio>
                        <el-radio :label="2">自定义跳转链接</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="分类图片" v-if="subUObj.type === 1">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="uploadSubImage" :auto-upload="true" :on-success="handleSubImageSuccess"
                        :on-remove="handleSubImageRemove" :file-list="fileListSubU" :limit="1">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="跳转链接" v-if="subUObj.type === 2">
                    <el-input placeholder="请输入跳转链接" prefix-icon="el-icon-link" v-model="subUObj.link"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subSubUp('subUObj')">确 定</el-button>
                <el-button @click="subUpg = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { queryClassifys, querySubClassifys, addClassify, updateClassify, delClassify } from '@/api';
export default {
    name: "ClassifyAdm",
    data() {
        return {
            pageC: 1,
            sizeC: 10,
            classifys: [],
            tianC: false,
            upgC: false,
            loadingC: false,
            cyObj: {
                name: '',
                sort: 0,
                type: 1,
                image: '',
                cover: '',
                link: '',
                details: ''
            },
            cyUObj: {},
            subShow: false,
            subTian: false,
            subUpg: false,
            currentParentCid: null,
            subList: [],
            subObj: {
                name: '',
                sort: 0,
                type: 1,
                image: '',
                link: '',
                details: '',
                parentId: 0
            },
            subUObj: {},
            fileListCover: [],
            fileListUCover: [],
            fileListSub: [],
            fileListSubU: [],
            rulesA: {
                name: [
                    { required: true, message: "分类名称不能为空", trigger: "blur" }
                ],
                type: [
                    { required: true, message: "请选择操作模式", trigger: "change" }
                ]
            },
            rulesU: {
                name: [
                    { required: true, message: "分类名称不能为空", trigger: "blur" }
                ],
                type: [
                    { required: true, message: "请选择操作模式", trigger: "change" }
                ]
            },
            rulesSub: {
                name: [
                    { required: true, message: "子分类名称不能为空", trigger: "blur" }
                ]
            },
            rulesSubU: {
                name: [
                    { required: true, message: "子分类名称不能为空", trigger: "blur" }
                ]
            },
        };
    },
    computed: {
        dialogWidthSmall() {
            return window.innerWidth < 768 ? '95%' : '500px';
        },
        dialogWidth() {
            return window.innerWidth < 768 ? '95%' : '75%';
        },
        classifyList() {
            const parents = this.classifys
                ? this.classifys.filter(c => !c.parentId || c.parentId === 0)
                : [];
            return parents.slice(
                (this.pageC - 1) * this.sizeC,
                this.pageC * this.sizeC
            );
        },
        classifyTotal() {
            const parents = this.classifys
                ? this.classifys.filter(c => !c.parentId || c.parentId === 0)
                : [];
            return parents.length;
        }
    },
    methods: {
        handleClassifyUp(index, row) {
            let obj = JSON.stringify(row);
            obj = JSON.parse(obj);
            if (!obj.type) obj.type = 1;
            this.cyUObj = obj;
            this.fileListUCover = obj.coverUrl ? [{ url: obj.coverUrl }] : [];
            this.upgC = true;
        },
        handleSubManage(row) {
            this.currentParentCid = row.cid;
            this.subShow = true;
            this.getSubClassifys();
        },
        async getSubClassifys() {
            if (!this.currentParentCid) return;
            let res = await querySubClassifys(this.currentParentCid);
            let { code, data } = res;
            if (code != 0) {
                this.$message.error('获取子分类失败');
                return;
            }
            this.subList = data || [];
        },
        subSubAdd(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定添加该子分类?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = { ...this.subObj };
                        obj.parentId = this.currentParentCid;
                        addClassify(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.subTian = false;
                            this.$message.success(msg);
                            this.subObj = {
                                name: '',
                                sort: 0,
                                type: 1,
                                image: '',
                                link: '',
                                details: '',
                                parentId: 0
                            };
                            this.fileListSub = [];
                            this.getSubClassifys();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        subSubUp(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定修改该子分类?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.subUObj;
                        updateClassify(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.subUpg = false;
                            this.$message.success(msg);
                            this.getSubClassifys();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        handleSubUp(index, row) {
            let obj = JSON.stringify(row);
            obj = JSON.parse(obj);
            if (!obj.type) obj.type = 1;
            this.subUObj = obj;
            this.fileListSubU = obj.imageUrl ? [{ url: obj.imageUrl }] : [];
            this.subUpg = true;
        },
        handleSubDe(index, row) {
            this.$confirm("此操作将永久删除该子分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delClassify(row.cid).then((res) => {
                    if (res.code != 0) {
                        this.$message.error(res.msg);
                        return false;
                    }
                    this.$message.success('删除成功');
                    this.subList = this.subList.filter((todo) => todo.cid != row.cid);
                })
            });
        },
        handleClassifyCoverSuccess(res, file) {
            if (res.code != 0) {
                this.$message.error('上传失败');
                return;
            }
            const data = res.data || {};
            const key = data.key;
            const previewUrl = data.url;
            file.url = previewUrl;
            if (this.upgC) {
                this.cyUObj.cover = key;
                this.fileListUCover = [{ url: previewUrl }];
            } else {
                this.cyObj.cover = key;
                this.fileListCover = [{ url: previewUrl }];
            }
            if (this.$refs.uploadClassifyCover) {
                this.$refs.uploadClassifyCover.clearFiles();
            }
        },
        handleSubImageSuccess(res, file) {
            if (res.code != 0) {
                this.$message.error('上传失败');
                return;
            }
            const data = res.data || {};
            const key = data.key;
            const previewUrl = data.url;
            file.url = previewUrl;
            if (this.subUpg) {
                this.subUObj.image = key;
                this.fileListSubU = [{ url: previewUrl }];
            } else {
                this.subObj.image = key;
                this.fileListSub = [{ url: previewUrl }];
            }
            if (this.$refs.uploadSubImage) {
                this.$refs.uploadSubImage.clearFiles();
            }
        },
        handleClassifyCoverRemove() {
            if (this.upgC) {
                this.cyUObj.cover = '';
                this.fileListUCover = [];
            } else {
                this.cyObj.cover = '';
                this.fileListCover = [];
            }
        },
        handleSubImageRemove() {
            if (this.subUpg) {
                this.subUObj.image = '';
                this.fileListSubU = [];
            } else {
                this.subObj.image = '';
                this.fileListSub = [];
            }
        },
        subCAdd(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定添加该分类?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.cyObj;
                        addClassify(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.tianC = false;
                            this.$msg({
                                showClose: true,
                                message: msg,
                                type: "success",
                            });
                            this.cyObj = {
                                name: '',
                                sort: 0,
                                type: 1,
                                image: '',
                                cover: '',
                                link: '',
                                details: ''
                            };
                            this.fileListCover = [];
                            this.getClassify();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        subCUp(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定修改该分类?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.cyUObj;
                        updateClassify(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.upgC = false;
                            this.$msg({
                                showClose: true,
                                message: msg,
                                type: "success",
                            });
                            this.getClassify();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        handleClassifyDe(index, row) {
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delClassify(row.cid).then((res) => {
                    if (res.code != 0) {
                        this.$msg({
                            showClose: true,
                            message: res.msg,
                            type: "error",
                        });
                        return false;
                    }
                    this.$msg({
                        showClose: true,
                        message: '删除成功',
                        type: "success",
                    });
                    this.loadingC = true
                    this.classifys = this.classifys.filter((todo) => {
                        return todo.cid != row.cid;
                    })
                    setTimeout(() => {
                        this.loadingC = false
                    }, 500)
                })
            });
        },
        handleBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            return suffix || suffix2 || suffix3
        },
        handleCurrentClassifyChange(val) {
            this.pageC = val;
            this.getClassify();
        },
        async getClassify() {
            this.loadingC = true;
            let res = await queryClassifys()
            let { code, data } = res;
            if (code != 0) {
                this.$message.error('出现错误');
                return false;
            }
            this.classifys = data;
            setTimeout(() => {
                this.loadingC = false;
            }, 300)
        }
    },
    created() {
        this.getClassify();
    }
};
</script>

<style scoped>
.classify-page {
    height: calc(100vh - 110px);
    overflow-y: auto;
}

.title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}

.handle-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;
}

.table {
    width: 100%;
    font-size: 14px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 60px;
    height: 60px;
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .classify-page {
    height: calc(100vh - 56px);
  }
  .title {
    font-size: 15px;
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .classify-page {
    height: calc(100vh - 56px);
  }
}
</style>
